import { IconButtonProps } from "@rjsf/utils";

export const AddButton = (props: IconButtonProps) => {
  const { icon, iconType, ...btnProps } = props;
  const { style: _, ...newBtnProps } = btnProps;
  return (
    <button
      {...newBtnProps}
      className="pulse-btn--success-400 pulse-color--background-900 pulse-typography-body-2"
      style={{ marginTop: "15px" }}
    >
      Add New Destination
    </button>
  );
};
